import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { db } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';

const Deposit = ({ loading, handleCloseModal }) => {
  const [copied, setCopied] = useState(false);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ amount: '', crypto: '' });
  const [wallets, setWallets] = useState({}); // store key→{name,address}

  useEffect(() => {
    async function fetchWallets() {
      try {
        const snap = await getDoc(doc(db, 'shipments', 'bitworld'));
        if (snap.exists()) {
          const data = snap.data();
          const sorted = Object.entries(data)
            .filter(([k]) => /^wallet\d+$/.test(k))
            .sort((a, b) => parseInt(a[0].replace('wallet', ''), 10) - parseInt(b[0].replace('wallet', ''), 10))
            .reduce((obj, [k, w]) => {
              obj[k] = { name: w.name, address: w.address };
              return obj;
            }, {});
          setWallets(sorted);
          const first = Object.values(sorted)[0]?.name || '';
          setForm(prev => ({ ...prev, crypto: first }));
        }
      } catch (err) {
        console.error('Error loading wallets:', err);
      }
    }
    fetchWallets();
  }, []);

  const handleCopy = text => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 4000);
    });
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.amount || Number(form.amount) <= 0) {
      alert('Please enter a valid amount.');
      return;
    }
    setStep(2);
  };

  if (loading) {
    return (
      <>
        <div className="overlaid" onClick={() => handleCloseModal('deposit')} />
        <div className="USDT-deposit">
          <h2>Deposit Crypto to Start</h2>
          <p>Loading wallet addresses...</p>
          <span className="close" onClick={() => handleCloseModal('deposit')}>
            &times; Close
          </span>
        </div>
      </>
    );
  }

  const selectedEntry = Object.values(wallets).find(w => w.name === form.crypto);
  const selectedAddress = selectedEntry?.address || '';

  return (
    <>
      <div className="overlaid" onClick={() => handleCloseModal('deposit')} />
      <div className="USDT-deposit">
        {copied && <div className="copied-notification">Copied!</div>}

        {step === 1 ? (
          <>
            <h2>Enter Deposit Details</h2>
            <form onSubmit={handleSubmit}>
              <label>
                Amount:
                <input
                  className="input-field"
                  type="number"
                  name="amount"
                  placeholder="eg. 1000"
                  value={form.amount}
                  onChange={handleInputChange}
                  min="0"
                  step="any"
                  required
                />
              </label>

              <label>
                Select Crypto:
                <select
                  className="input-field"
                  name="crypto"
                  value={form.crypto}
                  onChange={handleInputChange}
                  required
                >
                  {Object.values(wallets).map(w => (
                    <option key={w.name} value={w.name}>
                      {w.name.toUpperCase()}
                    </option>
                  ))}
                </select>
              </label>

              <button type="submit" className="delete-button">
                Continue
              </button>
            </form>
          </>
        ) : (
          <>
            <h2>Deposit Instructions</h2>
            <p className="box-text">
              Please send exactly <strong>{form.amount}</strong> worth of {form.crypto.toUpperCase()} to the address below.
            </p>

            <div className="crypto-address-box">
              <div className="qr-code-container">
                <QRCodeSVG value={selectedAddress} size={120} level="H" />
              </div>
              <div className="address-info">
                <h3>{form.crypto.toUpperCase()}</h3>
                <div className="address-container">
                  <p className="address">{selectedAddress}</p>
                  <button className="copy-button" onClick={() => handleCopy(selectedAddress)}>
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                </div>
              </div>
            </div>

            <button className="delete-button" onClick={() => setStep(1)}>
              Change Amount / Crypto
            </button>
          </>
        )}

        <span className="close" onClick={() => handleCloseModal('deposit')}>
          &times; Close
        </span>
      </div>
    </>
  );
};

export default Deposit;